// @flow
import { bindActionCreators} from "redux";
import { connect } from 'react-redux';
import CheckoutAsyncSuccess from "../components/CheckoutAsyncResponse/CheckoutAsyncSuccess";
import { actions as AlertActions } from '../../../alert/duck';

import { replace } from "react-router-redux";

function mapDispatchToProps(dispatch: Function) {
  return {
    ...bindActionCreators({
      ...AlertActions,
      goToRedirect: (route: string) => replace(route),
    }, dispatch),
    dispatch,
  }
}

export default connect(undefined, mapDispatchToProps)(CheckoutAsyncSuccess)



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/containers/CheckoutAsyncSuccessContainer.js